/**
 * @license
 * Copyright (c) 2017, Absa Group Limited, All Rights Reserved.
 */

// Angular
import { Component, Output, EventEmitter, OnInit, ElementRef, ViewChild } from '@angular/core';

// RXJS
import { Observable } from "rxjs/Observable";

// Translate
import { TranslateService } from '@ngx-translate/core';

// NGRX
import { Store } from '@ngrx/store';

// @Celine API
import { User } from '@api/models';
import { getUser } from '@api/store/app-store';

// @Threshold
import { getUserProfiles } from '../../store/store';
import { UserProfile } from '../../models/user';

import { getLocalizationDefaultLang } from '../../store/store';
import * as thresholdActions from '../../store/actions/actions';
import { FGWService } from '../../services/fgw.service';


declare var window: any;

interface LanguageResource {
	name: string;
	code: string
}

@Component({
	selector: 'celine-threshold-user-dropdown',
	template: require('./user-dropdown.component.html')
})

export class UserDropdownComponent implements OnInit {

	// Ouput
	@Output('logout') logout = new EventEmitter();

	// ViewChild
	@ViewChild('languageDropdown') languageDropdown: ElementRef;
	@ViewChild('languageToggleIcon') languageToggleIcon: ElementRef;

	// Observables
	user$: Observable<User>;
	userProfiles$: Observable<UserProfile[]>;
	lang$: Observable<string>;

	userName: string;
	userEmailAddress: string;

	activeLocaleLang: string;
	activeLocaleCountry: string;


	activeLanguage: LanguageResource;
	availableConfigLanguages: string[]; // Available languages on this domain
	toggleableLanguages: LanguageResource[] = [];
	languageResource: any; // Language resources Name + Code
	showLanguagesOption: boolean = false;
	public isAbsaTheme: boolean;
	public showMobileAppProfileLink: boolean;
	showLanguageChange: boolean;
	public showMobileUserMenu: boolean;

	// Feature flag
	featTogLocalization = process.env.config.feature.localization.enabled;
	featTogLanguage = process.env.config.feature.language.enabled;
	featMFADeviceManagement = process.env.config.feature.MFADeviceManagement.enabled;
	featTogChangePassword = process.env.config.feature.changePassword.enabled;



	/**
	 *
	 */

	constructor(private store: Store<any>,
		private translateService: TranslateService,
		private fgw: FGWService) {

		this.user$ = this.store.select(getUser);
		this.userProfiles$ = this.store.select(getUserProfiles);
		this.lang$ = this.store.select(getLocalizationDefaultLang);

		// getTheme
		this.isAbsaTheme = this.fgw.getTheme().toLowerCase() === 'absa' || this.fgw.getTheme().toLowerCase() === 'absav2' ? true : false;
		
		// subscribe to user$, concatenate user name for UI
		this.user$.subscribe(user => {
			this.userName = this.concatUserName(user);
		});

		this.userProfiles$.subscribe(userProfiles => {
			this.userEmailAddress = userProfiles.some(profile => profile.isSelected) ? userProfiles.find(profile => profile.isSelected).emailAddress : '';
		});


		if ((this.featTogLanguage) && (typeof JSON.parse(window['__CONFIGURATION'])['languages'] !== "undefined")) {
			this.availableConfigLanguages = JSON.parse(window['__CONFIGURATION'])['languages'];
			this.languageResource = process.env.config.feature.language.language_codes;

			if (this.availableConfigLanguages.length > 0) {
				this.showLanguagesOption = true;

				for (let i = 0; i < this.availableConfigLanguages.length; i++) {
					let resource = this.languageResource.find(o => o.code === this.availableConfigLanguages[i]) as LanguageResource;
					let languageObj = {
						name: resource.name,
						code: resource.code
					}

					this.toggleableLanguages.push(languageObj);
				}
			}

			this.lang$.subscribe((languageCountryCode) => {
				this.activeLanguage = this.languageResource.find(o => o.code === languageCountryCode.split('-')[0]) as LanguageResource;
				let locate = languageCountryCode.split('-');
				this.activeLocaleLang = locate[0];
				this.activeLocaleCountry = locate[1];
		
			});
		}

		this.showLanguageChange = JSON.parse(window['__CONFIGURATION'])['canChangePassword'] ? JSON.parse(window['__CONFIGURATION'])['canChangePassword'] : false;
		this.showMobileUserMenu = JSON.parse(window['__CONFIGURATION'])['supportMobileMfa'] ? JSON.parse(window['__CONFIGURATION'])['supportMobileMfa'] : false;
	}



	ngOnInit() {
	}

	logoutClick() {
		this.logout.emit();
	}

	/**
	 * 
	 * @param user 
	 */
	private concatUserName(user: User): string {
		if (user) {
			let userName: string = user.username;
			let firstName: string = user.firstName;
			let lastName: string = user.lastName;

			if (firstName === '' && lastName === '' && userName.includes('@')) {
				// try to parse name from email address
				let email: string = userName.substring(0, userName.indexOf('@'));

				if ((email.indexOf('.') > -1)
					&& (email.indexOf('.') === email.lastIndexOf('.'))) {
					// just one dot, split to first and last
					firstName = email.split('.')[0];
					lastName = email.split('.')[1];
				}
				else {
					firstName = email;
				}
			}

			let concatName = (firstName !== '') ? firstName + ' ' : '';
			concatName += (lastName !== '') ? lastName : '';

			return (concatName === '') ? userName.trim() : concatName.trim();
		}

		return '';

	}

	public toggleLang(ev: MouseEvent) {

		this.languageDropdown.nativeElement.classList.toggle("d-none");
		this.languageToggleIcon.nativeElement.classList.toggle("ico-chevron-up");
		this.languageToggleIcon.nativeElement.classList.toggle("ico-chevron-down");
		ev.stopPropagation();
	}


	public switchLanguage(language, langNameCode) {
		this.activeLanguage = langNameCode;
		this.store.dispatch(new thresholdActions.SetLocalizationDefaultLangAction(language + '-' + this.activeLocaleCountry));
	}

	public changePassword() {
		this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));
		window.location.href = `${JSON.parse(window['__CONFIGURATION'])['authUrl']}/Change/ChangePassword`;
	}

	public contactUs() { 
    	window.open(`${JSON.parse(window['__CONFIGURATION'])['authUrl']}/ContactUs`, "_blank");
	}}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/user/user-dropdown.component.ts